var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.type === 'telemedicine')?_c('OnlineConsultationIcon'):(_vm.type === 'visit')?_c('ClinicIcon'):(_vm.type === 'house_call')?_c('AmbulanceIcon'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }